import { Component, OnInit } from '@angular/core';
import {WorkspaceService} from '../../../workspace.service';

@Component({
  standalone: false,
  selector: 'app-joint-info-mobile',
  templateUrl: './joint-info-mobile.component.html',
  styleUrls: ['./joint-info-mobile.component.scss']
})
export class JointInfoMobileComponent implements OnInit {

  constructor(public workspaceService: WorkspaceService) { }

  ngOnInit() {
  }

}
